var render = function render(){
  var _vm$detailProjectCont4, _vm$detailProjectCont5, _vm$detailProjectCont6, _vm$detailProjectCont7, _vm$detailProjectCont8, _vm$detailProjectCont9, _vm$detailProjectCont0, _vm$detailProjectCont1, _vm$detailProjectCont10, _vm$detailProjectCont11, _vm$detailProjectCont12, _vm$detailProjectCont13, _vm$detailProjectCont14, _vm$detailProjectCont15, _vm$detailProjectCont16, _vm$detailProjectCont17, _vm$detailProjectCont18, _vm$detailProjectCont19, _vm$detailProjectCont20, _vm$projectDetail, _vm$projectDetail2, _vm$projectDetail3, _vm$projectDetail4, _vm$detailProjectCont21, _vm$customerDetail$ac, _vm$customerDetail, _vm$customerDetail2, _vm$customerDetail$ad, _vm$customerDetail3, _ref, _vm$customerDetail$ph, _vm$customerDetail4, _vm$customerDetail5, _vm$customerDetail$em, _vm$customerDetail6, _vm$customerDetail$co, _vm$customerDetail7, _vm$customerDetail$pr, _vm$customerDetail8, _vm$customerDetail$ci, _vm$customerDetail9, _vm$customerDetail$di, _vm$customerDetail0, _vm$customerDetail$vi, _vm$customerDetail1, _vm$customerDetail$na, _vm$customerDetail10, _ref2, _vm$customerDetail$mo, _vm$customerDetail11, _vm$customerDetail12, _vm$detailProjectCont22, _vm$detailProjectCont23, _vm$form, _vm$form2, _vm$form3, _vm$form4, _vm$form$contract_typ, _vm$detailProjectCont24, _vm$detailProjectCont25, _vm$detailProjectCont26, _vm$detailProjectCont27, _vm$detailProjectCont28, _vm$detailProjectCont29, _vm$detailProjectCont30, _vm$detailProjectCont31, _vm$totalQuantityAdd, _vm$form5, _vm$form5$laycan, _vm$form6, _vm$form6$laycan, _vm$form7, _vm$form7$laycan, _vm$form8, _vm$form8$laycan, _Number, _vm$form9, _vm$form9$distance, _vm$optionsCurrency, _vm$optionsCurrency$f, _vm$form1, _vm$optionsCurrency2, _vm$optionsCurrency2$, _vm$optionsCurrency3, _vm$optionsCurrency3$, _Number2, _vm$optionsCurrency4, _vm$optionsCurrency4$, _Number3, _vm$detailProjectCont32, _vm$detailProjectCont33, _vm$form10, _vm$form10$formTender, _vm$form$formTender, _vm$form$formTender2, _vm$detailProjectCont34, _vm$detailProjectCont35, _vm$detailProjectCont36, _vm$detailProjectCont37, _vm$detailProjectCont38, _vm$detailProjectCont39, _vm$detailProjectCont40;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.detail_project_loading ? _c('form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.onSavePlan.apply(null, arguments);
      }
    }
  }, [_c('b-row', {
    staticClass: "m-3"
  }, [['EDIT', 'PREVIEW'].includes(_vm.action) ? _c('b-col', {
    staticClass: "mb-4",
    attrs: {
      "lg": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center w-100 justify-content-end"
  }, _vm._l(_vm.listProjectStage, function (state, index) {
    var _vm$detailProjectCont, _vm$detailProjectCont3, _vm$listProjectStage;
    return _c('div', {
      key: index
    }, [_c('b-badge', {
      staticClass: "border border-primary text-primary text-uppercase",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "variant": ((_vm$detailProjectCont = _vm.detailProjectContract) === null || _vm$detailProjectCont === void 0 ? void 0 : _vm$detailProjectCont.detail_project_stage_id) === state.id ? 'primary' : 'none'
      },
      on: {
        "click": function click($event) {
          var _vm$detailProjectCont2;
          return _vm.onChangeStatusStage((_vm$detailProjectCont2 = _vm.detailProjectContract) === null || _vm$detailProjectCont2 === void 0 ? void 0 : _vm$detailProjectCont2.id, state.id);
        }
      }
    }, [_c('span', {
      class: ((_vm$detailProjectCont3 = _vm.detailProjectContract) === null || _vm$detailProjectCont3 === void 0 ? void 0 : _vm$detailProjectCont3.detail_project_stage_id) === state.id ? 'text-white' : ''
    }, [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : state.title))])]), ((_vm$listProjectStage = _vm.listProjectStage) === null || _vm$listProjectStage === void 0 ? void 0 : _vm$listProjectStage.length) - 1 !== index ? _c('strong', [_vm._v(" >> ")]) : _vm._e()], 1);
  }), 0)]) : _vm._e(), ['EDIT', 'PREVIEW'].includes(_vm.action) ? _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "lg": "12"
    }
  }, [_c('b-row', [_c('div', {
    class: "col-md-2 ".concat(_vm.activeTab === 1 ? 'bg-primary' : 'text-muted', " py-2 px-2 rounded-circle justify-content-center d-flex"),
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function click($event) {
        _vm.activeTab = 1;
      }
    }
  }, [_c('strong', [_vm._v("General")])]), _c('div', {
    class: "col-md-2 ".concat(_vm.activeTab === 2 ? 'bg-primary' : 'text-muted', " py-2 px-2 rounded-circle justify-content-center d-flex"),
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function click($event) {
        _vm.activeTab = 2;
      }
    }
  }, [_c('strong', [_vm._v("Form List")])]), _c('div', {
    class: "col-md-2 ".concat(_vm.activeTab === 3 ? 'bg-primary' : 'text-muted', " py-2 px-2 rounded-circle justify-content-center d-flex"),
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function click($event) {
        _vm.activeTab = 3;
      }
    }
  }, [_c('strong', [_vm._v("PFA")])]), (_vm$detailProjectCont4 = _vm.detailProjectContract) !== null && _vm$detailProjectCont4 !== void 0 && (_vm$detailProjectCont5 = _vm$detailProjectCont4.contract_type) !== null && _vm$detailProjectCont5 !== void 0 && _vm$detailProjectCont5.is_spal ? _c('div', {
    staticClass: "col-md-2 p-0",
    class: "col-md-2 ".concat(_vm.activeTab === 4 ? 'bg-primary' : 'text-muted', " py-2 px-2 rounded-circle justify-content-center d-flex"),
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function click($event) {
        _vm.activeTab = 4;
      }
    }
  }, [_c('strong', [_vm._v("Spal Process")])]) : _vm._e(), (_vm$detailProjectCont6 = _vm.detailProjectContract) !== null && _vm$detailProjectCont6 !== void 0 && (_vm$detailProjectCont7 = _vm$detailProjectCont6.project_stage) !== null && _vm$detailProjectCont7 !== void 0 && _vm$detailProjectCont7.is_running ? _c('div', {
    class: "col-md-2 ".concat(_vm.activeTab === 5 ? 'bg-primary' : 'text-muted', " py-2 px-2 rounded-circle justify-content-center d-flex"),
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function click($event) {
        _vm.activeTab = 5;
      }
    }
  }, [_c('strong', [_vm._v("Trip Document")])]) : _vm._e(), (_vm$detailProjectCont8 = _vm.detailProjectContract) !== null && _vm$detailProjectCont8 !== void 0 && (_vm$detailProjectCont9 = _vm$detailProjectCont8.project_stage) !== null && _vm$detailProjectCont9 !== void 0 && _vm$detailProjectCont9.is_running || (_vm$detailProjectCont0 = _vm.detailProjectContract) !== null && _vm$detailProjectCont0 !== void 0 && (_vm$detailProjectCont1 = _vm$detailProjectCont0.project_stage) !== null && _vm$detailProjectCont1 !== void 0 && _vm$detailProjectCont1.is_end_stage ? _c('div', {
    class: "col-md-2 ".concat(_vm.activeTab === 6 ? 'bg-primary' : 'text-muted', " py-2 px-2 rounded-circle justify-content-center d-flex"),
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function click($event) {
        _vm.activeTab = 6;
      }
    }
  }, [_c('strong', [_vm._v("Payment List")])]) : _vm._e(), ['Running'].includes((_vm$detailProjectCont10 = _vm.detailProjectContract) === null || _vm$detailProjectCont10 === void 0 ? void 0 : (_vm$detailProjectCont11 = _vm$detailProjectCont10.project_stage) === null || _vm$detailProjectCont11 === void 0 ? void 0 : _vm$detailProjectCont11.title) ? _c('div', {
    class: "col-md-2 ".concat(_vm.activeTab === 7 ? 'bg-primary' : 'text-muted', " py-2 px-2 rounded-circle justify-content-center d-flex"),
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function click($event) {
        _vm.activeTab = 7;
      }
    }
  }, [_c('strong', [_vm._v("Real Shipment")])]) : _vm._e()]), _c('hr')], 1) : _vm._e(), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_vm.activeTab === 1 ? _c('div', {
    attrs: {
      "id": "general"
    }
  }, [['EDIT', 'PREVIEW'].includes(_vm.action) ? _c('b-col', {
    staticClass: "mb-4",
    attrs: {
      "lg": "12"
    }
  }, [_c('div', {
    class: "d-flex align-items-center justify-content-end w-100"
  }, [['EDIT'].includes(_vm.action) ? _c('b-button', {
    staticClass: "mt-2 mr-3",
    attrs: {
      "disabled": _vm.saving,
      "variant": "primary",
      "type": "submit"
    }
  }, [_vm.saving ? _c('span', {
    staticClass: "spinner-border spinner-border-sm"
  }) : _c('div', [_c('i', {
    staticClass: "fa fa-save"
  }), _c('span', [_vm._v("Save Data")])])]) : _vm._e(), ['EDIT'].includes(_vm.action) ? _c('b-button', {
    staticClass: "mt-2 mr-3",
    attrs: {
      "disabled": _vm.saving,
      "type": "button",
      "variant": "danger"
    },
    on: {
      "click": function click($event) {
        return _vm.changeAction('PREVIEW');
      }
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-ban"
  }), _c('span', [_vm._v("Cancel")])])]) : _vm._e(), ['EDIT', 'PREVIEW'].includes(_vm.action) ? _c('b-button', {
    staticClass: "mr-2 mt-2",
    attrs: {
      "variant": "dark"
    },
    on: {
      "click": _vm.saveDraft
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v("Save Draft")]) : _vm._e(), ['PREVIEW'].includes(_vm.action) ? _c('b-button', {
    staticClass: "mt-2",
    attrs: {
      "type": "button",
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.changeAction('EDIT');
      }
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-pen"
  }), _c('span', [_vm._v("Edit Data")])])]) : _vm._e()], 1)]) : _vm._e(), ['ADD'].includes(_vm.action) ? _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center justify-content-end w-100"
  }, [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "dark"
    },
    on: {
      "click": _vm.saveDraft
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v("Save Draft")]), _c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.pasteDraft
    }
  }, [_c('i', {
    staticClass: "fa fa-clipboard"
  }), _vm._v("Paste Draft")]), _c('b-button', {
    attrs: {
      "disabled": _vm.saving,
      "variant": "primary",
      "type": "submit"
    }
  }, [_vm.saving ? _c('span', {
    staticClass: "spinner-border spinner-border-sm"
  }) : _c('div', [_c('i', {
    staticClass: "fa fa-save"
  }), _c('span', [_vm._v("Submit Data")])])])], 1)]) : _vm._e(), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('fieldset', {
    staticClass: "form-group border p-3"
  }, [_c('legend', {
    staticClass: "w-auto px-2 text-primary"
  }, [_vm._v("Project")]), ['ADD'].includes(_vm.action) ? _c('b-row', [_c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('b-alert', {
    attrs: {
      "show": true,
      "variant": "primary"
    }
  }, [_vm._l(_vm.company, function (item, index) {
    return [_c('b-form-radio', {
      key: index,
      attrs: {
        "inline": "",
        "name": item.name,
        "value": item.value
      },
      model: {
        value: _vm.project_type,
        callback: function callback($$v) {
          _vm.project_type = $$v;
        },
        expression: "project_type"
      }
    }, [_vm._v(_vm._s(item.label))])];
  })], 2)], 1)], 1) : _vm._e(), _c('b-row', [_vm.project_type === 'existing' && ['ADD'].includes(_vm.action) ? _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('b-form-group', {
    staticClass: "mr-2",
    attrs: {
      "label": "New Subproject",
      "label-for": "new_sub_project"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "name": "new_sub_project",
      "switch": "",
      "inline": ""
    },
    model: {
      value: _vm.form.new_sub_project,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "new_sub_project", $$v);
      },
      expression: "form.new_sub_project"
    }
  }, [_vm._v(" Yes / No ")])], 1)], 1) : _vm._e(), _vm.project_type === 'existing' ? _c('b-col', {
    attrs: {
      "lg": "6"
    }
  }, [['ADD'].includes(_vm.action) && _vm.form.new_sub_project ? _c('div', [_vm.form.new_sub_project ? _c('b-form-group', {
    attrs: {
      "label-for": "projects_options",
      "label": "Projects"
    }
  }, [['ADD', 'EDIT'].includes(_vm.action) ? _c('v-select', {
    attrs: {
      "label": "label",
      "name": "new_project_id",
      "track-by": "value",
      "options": _vm.projects_options,
      "reduce": function reduce(projects_options) {
        return projects_options.value;
      },
      "getOptionKey": function getOptionKey(option) {
        return option.label;
      },
      "placeholder": "Select Project",
      "required": ""
    },
    on: {
      "input": _vm.onSelectedNewProject
    },
    model: {
      value: _vm.form.new_project_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "new_project_id", $$v);
      },
      expression: "form.new_project_id"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm.form.new_project_id ? _c('b-form-group', {
    attrs: {
      "label": "Sub Project",
      "label-for": "sub_project_name"
    }
  }, [_c('b-form-input', {
    staticClass: "d-inline-block",
    attrs: {
      "id": "port_name",
      "type": "text",
      "placeholder": "Sub Project Name",
      "maxlength": "30"
    },
    model: {
      value: _vm.form.sub_project_name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "sub_project_name", $$v);
      },
      expression: "form.sub_project_name"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), !_vm.form.new_sub_project ? _c('b-form-group', {
    attrs: {
      "label-for": "project_sub_id",
      "label": "Projects"
    }
  }, [['ADD', 'EDIT'].includes(_vm.action) ? _c('v-select', {
    attrs: {
      "label": "text",
      "name": "project_sub_id",
      "options": _vm.projects,
      "reduce": function reduce(projects) {
        return projects.value;
      },
      "placeholder": "Select Project",
      "required": ""
    },
    on: {
      "input": _vm.onSelectedProject
    },
    model: {
      value: _vm.form.project_sub_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "project_sub_id", $$v);
      },
      expression: "form.project_sub_id"
    }
  }) : _c('strong', [_vm._v(_vm._s((_vm$detailProjectCont12 = _vm.detailProjectContract) === null || _vm$detailProjectCont12 === void 0 ? void 0 : (_vm$detailProjectCont13 = _vm$detailProjectCont12.project_sub) === null || _vm$detailProjectCont13 === void 0 ? void 0 : (_vm$detailProjectCont14 = _vm$detailProjectCont13.project) === null || _vm$detailProjectCont14 === void 0 ? void 0 : _vm$detailProjectCont14.project_name) + " - " + _vm._s((_vm$detailProjectCont15 = _vm.detailProjectContract) === null || _vm$detailProjectCont15 === void 0 ? void 0 : (_vm$detailProjectCont16 = _vm$detailProjectCont15.project_sub) === null || _vm$detailProjectCont16 === void 0 ? void 0 : _vm$detailProjectCont16.name))])], 1) : _vm._e()], 1) : _vm._e(), _c('b-col', {
    attrs: {
      "lg": _vm.project_type === 'new_project' ? '12' : '6'
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Customer",
      "label-for": "customer_id"
    }
  }, [['ADD', 'EDIT'].includes(_vm.action) ? _c('v-select', {
    attrs: {
      "label": "text",
      "name": "customer_id",
      "options": _vm.optionsListCustomer,
      "reduce": function reduce(optionsListCustomer) {
        return optionsListCustomer.value;
      },
      "placeholder": "Select Customer",
      "required": ""
    },
    on: {
      "input": function input($event) {
        return _vm.onSelectedCustomer(_vm.form.customer_id);
      }
    },
    model: {
      value: _vm.form.customer_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "customer_id", $$v);
      },
      expression: "form.customer_id"
    }
  }) : _c('strong', [_vm._v(_vm._s((_vm$detailProjectCont17 = _vm.detailProjectContract) === null || _vm$detailProjectCont17 === void 0 ? void 0 : (_vm$detailProjectCont18 = _vm$detailProjectCont17.customer) === null || _vm$detailProjectCont18 === void 0 ? void 0 : _vm$detailProjectCont18.customer_code) + " - " + _vm._s((_vm$detailProjectCont19 = _vm.detailProjectContract) === null || _vm$detailProjectCont19 === void 0 ? void 0 : (_vm$detailProjectCont20 = _vm$detailProjectCont19.customer) === null || _vm$detailProjectCont20 === void 0 ? void 0 : _vm$detailProjectCont20.account_name))])], 1)], 1)], 1), _vm.project_type === 'new_project' ? _c('b-button', {
    attrs: {
      "variant": "success",
      "size": "sm"
    },
    on: {
      "click": _vm.openCustomerSlide
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("   ADD NEW CUSTOMER")]) : _vm._e()], 1)]), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('b-row', [_vm.project_type === 'existing' && _vm.form.customer_id && _vm.form.project_sub_id ? _c('b-col', {
    attrs: {
      "lg": "6",
      "md": "12"
    }
  }, [_c('fieldset', {
    staticClass: "form-group border p-3"
  }, [_c('legend', {
    staticClass: "w-auto px-2 text-primary"
  }, [_vm._v("Project Info")]), _c('div', {
    staticClass: "d-flex w-100 overflow-auto"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-truncate"
  }, [_vm._v("PROJECT NAME")]), _c('th', {
    staticClass: "text-truncate"
  }, [_vm._v("PROJECT SUB NAME")]), _c('th', {
    staticClass: "text-truncate"
  }, [_vm._v("LOCATION")]), _c('th', [_vm._v("STATUS")])])]), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s((_vm$projectDetail = _vm.projectDetail) === null || _vm$projectDetail === void 0 ? void 0 : _vm$projectDetail.projectName))]), _c('td', [_vm._v(_vm._s((_vm$projectDetail2 = _vm.projectDetail) === null || _vm$projectDetail2 === void 0 ? void 0 : _vm$projectDetail2.projectSub))]), _c('td', [_vm._v(_vm._s((_vm$projectDetail3 = _vm.projectDetail) === null || _vm$projectDetail3 === void 0 ? void 0 : _vm$projectDetail3.location))]), _c('td', [_vm._v(_vm._s((_vm$projectDetail4 = _vm.projectDetail) !== null && _vm$projectDetail4 !== void 0 && _vm$projectDetail4.status ? 'Active' : 'Inactive'))])])])])])])]) : _vm._e(), ['EDIT', 'PREVIEW'].includes(_vm.action) ? _c('b-col', {
    attrs: {
      "lg": "6"
    }
  }, [_c('fieldset', {
    staticClass: "form-group border p-3"
  }, [_c('legend', {
    staticClass: "w-auto px-2 text-primary"
  }, [_vm._v("Log History Activity")]), _c('div', {
    staticClass: "overflow-auto d-flex w-100",
    staticStyle: {
      "max-height": "544px"
    }
  }, [_c('b-row', _vm._l((_vm$detailProjectCont21 = _vm.detailProjectContract) === null || _vm$detailProjectCont21 === void 0 ? void 0 : _vm$detailProjectCont21.project_log, function (state, index) {
    return _c('b-col', {
      key: index,
      staticClass: "mb-4",
      attrs: {
        "lg": "12"
      }
    }, [_c('div', {
      staticClass: "d-flex"
    }, [_c('strong', {
      staticClass: "mr-2"
    }, [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : state.name) + " -")]), _c('span', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(_vm.moment(state.date_log).format('DD MMMM YYYY')))])]), _c('span', [_vm._v(_vm._s(state.log_description))]), _c('br'), _c('strong', [_vm._v("----")])]);
  }), 1)], 1)])]) : _vm._e(), _vm.project_type === 'new_project' && _vm.form.customer_id && ['ADD'].includes(_vm.action) ? _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('fieldset', {
    staticClass: "form-group border p-3"
  }, [_c('legend', {
    staticClass: "w-auto px-2 text-primary"
  }, [_vm._v("Project Form")]), _c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.submitFormProject.apply(null, arguments);
      }
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Project Name",
      "label-for": "project_name"
    }
  }, [_c('v-multiselect', {
    attrs: {
      "placeholder": "Search or add new project",
      "label": "label",
      "track-by": "value",
      "close-on-select": true,
      "clear-on-select": true,
      "options": _vm.projects_options,
      "required": ""
    },
    on: {
      "search-change": _vm.searchProjects
    },
    model: {
      value: _vm.formProject.selected_project,
      callback: function callback($$v) {
        _vm.$set(_vm.formProject, "selected_project", $$v);
      },
      expression: "formProject.selected_project"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    on: {
      "click": _vm.doAddProject
    },
    slot: "noResult"
  }, [_vm._v(" Not Found. Click to add "), _c('strong', [_vm._v(_vm._s(_vm.formProject.projectName))])])])], 1), _c('b-form-group', {
    attrs: {
      "label": "Project Location",
      "label-for": "project_location"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "port_name",
      "type": "text",
      "placeholder": "Project Location",
      "maxlength": "30",
      "required": ""
    },
    model: {
      value: _vm.formProject.location,
      callback: function callback($$v) {
        _vm.$set(_vm.formProject, "location", $$v);
      },
      expression: "formProject.location"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Sub Project",
      "label-for": "sub_project_name"
    }
  }, [_c('b-form-input', {
    staticClass: "d-inline-block",
    attrs: {
      "id": "sub_project_name",
      "type": "text",
      "placeholder": "Sub Project Name",
      "maxlength": "30",
      "required": ""
    },
    model: {
      value: _vm.formProject.subName,
      callback: function callback($$v) {
        _vm.$set(_vm.formProject, "subName", $$v);
      },
      expression: "formProject.subName"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Ship to ship?",
      "label-for": "sts"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "name": "check-button",
      "switch": "",
      "inline": ""
    },
    model: {
      value: _vm.formProject.sts,
      callback: function callback($$v) {
        _vm.$set(_vm.formProject, "sts", $$v);
      },
      expression: "formProject.sts"
    }
  }, [_vm._v(" " + _vm._s(_vm.formProject.sts ? 'Yes' : 'No') + " ")])], 1)], 1)], 1)]) : _vm._e(), _c('b-col', {
    attrs: {
      "lg": "6",
      "md": "12"
    }
  }, [_vm.form.customer_id && _vm.project_type === 'existing' || _vm.project_type === 'new_project' && _vm.form.customer_id ? _c('fieldset', {
    staticClass: "form-group border p-3"
  }, [_c('legend', {
    staticClass: "w-auto px-2 text-primary"
  }, [_vm._v("Company Info")]), _c('div', {
    staticClass: "d-flex w-100 overflow-auto"
  }, [_c('table', {
    staticClass: "table mb-0 table-striped"
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "text-truncate",
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("Nama Perusahaan")]), _c('td', {
    attrs: {
      "width": "5%"
    }
  }, [_vm._v(":")]), _c('td', {
    staticClass: "text-truncate",
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s((_vm$customerDetail$ac = (_vm$customerDetail = _vm.customerDetail) === null || _vm$customerDetail === void 0 ? void 0 : _vm$customerDetail.account_name) !== null && _vm$customerDetail$ac !== void 0 ? _vm$customerDetail$ac : '-'))]), _c('th', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("Alamat")]), _c('td', {
    attrs: {
      "width": "5%"
    }
  }, [_vm._v(":")]), _c('td', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.top",
      value: (_vm$customerDetail2 = _vm.customerDetail) === null || _vm$customerDetail2 === void 0 ? void 0 : _vm$customerDetail2.address,
      expression: "customerDetail?.address",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "text-truncate",
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s((_vm$customerDetail$ad = (_vm$customerDetail3 = _vm.customerDetail) === null || _vm$customerDetail3 === void 0 ? void 0 : _vm$customerDetail3.address) !== null && _vm$customerDetail$ad !== void 0 ? _vm$customerDetail$ad : '-'))])]), _c('tr', [_c('th', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("No. Telepon")]), _c('td', {
    attrs: {
      "width": "5%"
    }
  }, [_vm._v(":")]), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s((_ref = (_vm$customerDetail$ph = (_vm$customerDetail4 = _vm.customerDetail) === null || _vm$customerDetail4 === void 0 ? void 0 : _vm$customerDetail4.phone1) !== null && _vm$customerDetail$ph !== void 0 ? _vm$customerDetail$ph : (_vm$customerDetail5 = _vm.customerDetail) === null || _vm$customerDetail5 === void 0 ? void 0 : _vm$customerDetail5.phone2) !== null && _ref !== void 0 ? _ref : '-'))]), _c('th', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("Email")]), _c('td', {
    attrs: {
      "width": "5%"
    }
  }, [_vm._v(":")]), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s((_vm$customerDetail$em = (_vm$customerDetail6 = _vm.customerDetail) === null || _vm$customerDetail6 === void 0 ? void 0 : _vm$customerDetail6.email) !== null && _vm$customerDetail$em !== void 0 ? _vm$customerDetail$em : '-'))])]), _c('tr', [_c('th', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("Negara")]), _c('td', {
    attrs: {
      "width": "5%"
    }
  }, [_vm._v(":")]), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s((_vm$customerDetail$co = (_vm$customerDetail7 = _vm.customerDetail) === null || _vm$customerDetail7 === void 0 ? void 0 : _vm$customerDetail7.country_id) !== null && _vm$customerDetail$co !== void 0 ? _vm$customerDetail$co : '-'))]), _c('th', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("Provinsi")]), _c('td', {
    attrs: {
      "width": "5%"
    }
  }, [_vm._v(":")]), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s((_vm$customerDetail$pr = (_vm$customerDetail8 = _vm.customerDetail) === null || _vm$customerDetail8 === void 0 ? void 0 : _vm$customerDetail8.province) !== null && _vm$customerDetail$pr !== void 0 ? _vm$customerDetail$pr : '-'))])]), _c('tr', [_c('th', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("Kota")]), _c('td', {
    attrs: {
      "width": "5%"
    }
  }, [_vm._v(":")]), _c('td', {
    staticClass: "text-truncate",
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s((_vm$customerDetail$ci = (_vm$customerDetail9 = _vm.customerDetail) === null || _vm$customerDetail9 === void 0 ? void 0 : _vm$customerDetail9.city) !== null && _vm$customerDetail$ci !== void 0 ? _vm$customerDetail$ci : '-'))]), _c('th', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("Kecamatan")]), _c('td', {
    attrs: {
      "width": "5%"
    }
  }, [_vm._v(":")]), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s((_vm$customerDetail$di = (_vm$customerDetail0 = _vm.customerDetail) === null || _vm$customerDetail0 === void 0 ? void 0 : _vm$customerDetail0.district) !== null && _vm$customerDetail$di !== void 0 ? _vm$customerDetail$di : '-'))])]), _c('tr', [_c('th', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("Kelurahan")]), _c('td', {
    attrs: {
      "width": "5%"
    }
  }, [_vm._v(":")]), _c('td', {
    staticClass: "text-truncate",
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s((_vm$customerDetail$vi = (_vm$customerDetail1 = _vm.customerDetail) === null || _vm$customerDetail1 === void 0 ? void 0 : _vm$customerDetail1.village) !== null && _vm$customerDetail$vi !== void 0 ? _vm$customerDetail$vi : '-'))]), _c('th', {
    attrs: {
      "width": "15%"
    }
  }), _c('td', {
    attrs: {
      "width": "5%"
    }
  }), _c('td', {
    attrs: {
      "width": "30%"
    }
  })]), _c('tr', [_c('th', {
    staticClass: "text-truncate",
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("PIC")]), _c('td', {
    attrs: {
      "width": "5%"
    }
  }, [_vm._v(":")]), _c('td', {
    staticClass: "text-truncate",
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s((_vm$customerDetail$na = (_vm$customerDetail10 = _vm.customerDetail) === null || _vm$customerDetail10 === void 0 ? void 0 : _vm$customerDetail10.name) !== null && _vm$customerDetail$na !== void 0 ? _vm$customerDetail$na : '-'))]), _c('th', {
    staticClass: "text-truncate",
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("No. Handphone")]), _c('td', {
    attrs: {
      "width": "5%"
    }
  }, [_vm._v(":")]), _c('td', {
    staticClass: "text-truncate",
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s((_ref2 = (_vm$customerDetail$mo = (_vm$customerDetail11 = _vm.customerDetail) === null || _vm$customerDetail11 === void 0 ? void 0 : _vm$customerDetail11.mobile1) !== null && _vm$customerDetail$mo !== void 0 ? _vm$customerDetail$mo : (_vm$customerDetail12 = _vm.customerDetail) === null || _vm$customerDetail12 === void 0 ? void 0 : _vm$customerDetail12.mobile2) !== null && _ref2 !== void 0 ? _ref2 : '-'))])])])])])]) : _vm._e()])], 1)], 1), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('b-row', [_vm.form.customer_id && _vm.form.project_sub_id && _vm.project_type === 'existing' || _vm.form.customer_id && _vm.form.new_project_id && _vm.form.sub_project_name && _vm.project_type === 'existing' || _vm.project_type === 'new_project' && _vm.form.customer_id ? _c('b-col', {
    attrs: {
      "lg": '12'
    }
  }, [_c('fieldset', {
    staticClass: "form-group border p-3"
  }, [_c('legend', {
    staticClass: "w-auto px-2 text-primary"
  }, [_vm._v("Detail Project Contract Form")]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Contract Number",
      "label-for": "contract"
    }
  }, [['ADD', 'EDIT'].includes(_vm.action) ? _c('b-form-input', {
    attrs: {
      "id": "contract_number",
      "type": "text",
      "placeholder": "Type text",
      "required": ""
    },
    model: {
      value: _vm.form.contract_number,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "contract_number", $$v);
      },
      expression: "form.contract_number"
    }
  }) : _c('strong', {
    staticClass: "text-capitalize"
  }, [_vm._v(_vm._s(_vm.form.contract_number))])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Company",
      "label-for": "company_id"
    }
  }, [['ADD', 'EDIT'].includes(_vm.action) ? _c('v-select', {
    staticClass: "w-100 mb-2",
    attrs: {
      "name": "company_id",
      "options": _vm.optionsCompanies,
      "label": "text",
      "track-by": "value",
      "reduce": function reduce(optionsCompanies) {
        return optionsCompanies.value;
      },
      "placeholder": "Select..."
    },
    model: {
      value: _vm.form.company_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "company_id", $$v);
      },
      expression: "form.company_id"
    }
  }) : _c('strong', {
    staticClass: "text-truncate"
  }, [_vm._v(_vm._s(_vm.showCompanyLabel(_vm.form.company_id)))])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Third Party",
      "label-for": "third_party"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "text-truncate",
    attrs: {
      "name": "check-button",
      "switch": "",
      "inline": "",
      "disabled": !['ADD', 'EDIT'].includes(_vm.action)
    },
    on: {
      "change": function change() {
        if (_vm.form.third_party) {
          _vm.form.fleet_ownership = 'chartered';
          _vm.onDataIntoPlan('fleet_ownership', _vm.form.fleet_ownership);
        } else {
          _vm.form.fleet_ownership = 'own-ship';
          _vm.onDataIntoPlan('fleet_ownership', _vm.form.fleet_ownership);
        }
      }
    },
    model: {
      value: _vm.form.third_party,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "third_party", $$v);
      },
      expression: "form.third_party"
    }
  }, [_vm._v(" Yes / No ")])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_vm.form.third_party ? _c('b-form-group', {
    attrs: {
      "label": "Third Party Company",
      "label-for": "third_party_company"
    }
  }, [['ADD', 'EDIT'].includes(_vm.action) ? _c('b-form-input', {
    staticClass: "w-100",
    attrs: {
      "id": "third_party_company",
      "type": "text",
      "placeholder": "Type text",
      "required": _vm.form.third_party ? true : false
    },
    model: {
      value: _vm.form.third_party_company,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "third_party_company", $$v);
      },
      expression: "form.third_party_company"
    }
  }) : _c('strong', {
    staticClass: "text-capitalize"
  }, [_vm._v(_vm._s(_vm.form.third_party_company))])], 1) : _vm._e()], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [[['ADD', 'EDIT'].includes(_vm.action) ? _c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('span', [_vm._v("Fleet ownership")]), _c('b-form-select', {
    staticClass: "form-control",
    attrs: {
      "plain": "",
      "required": "",
      "name": "fleet_ownership",
      "disabled": _vm.form.third_party
    },
    on: {
      "change": function change($event) {
        _vm.onDataIntoPlan('fleet_ownership', _vm.form.fleet_ownership);
        _vm.onChangeOwnership(_vm.form.fleet_ownership);
      }
    },
    model: {
      value: _vm.form.fleet_ownership,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "fleet_ownership", $$v);
      },
      expression: "form.fleet_ownership"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select ownership...")]), _c('option', {
    attrs: {
      "value": "own-ship"
    }
  }, [_vm._v("OWN SHIP")]), _c('option', {
    attrs: {
      "value": "chartered"
    }
  }, [_vm._v("CHARTERED")])])], 1), _vm.form.fleet_ownership ? _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('span', [_vm._v("Fleet Type")]), _c('b-form-select', {
    staticClass: "form-control",
    attrs: {
      "plain": "",
      "options": _vm.optionsFleetTypes,
      "required": "",
      "name": "fleet_type_id"
    },
    on: {
      "change": function change($event) {
        _vm.onChangeFleetType(false, null, null);
        _vm.onDataIntoPlan('fleet_type_id', _vm.form.fleet_type_id);
      }
    },
    scopedSlots: _vm._u([{
      key: "first",
      fn: function fn() {
        return [_c('b-form-select-option', {
          attrs: {
            "value": null
          }
        }, [_vm._v("Select fleet type...")])];
      },
      proxy: true
    }], null, false, 2802890174),
    model: {
      value: _vm.form.fleet_type_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "fleet_type_id", $$v);
      },
      expression: "form.fleet_type_id"
    }
  })], 1) : _vm._e()], 1)], 1) : _c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "lg": "6"
    }
  }, [_c('span', [_vm._v("Fleet ownership")]), _vm._v(" "), _c('br'), _c('b-badge', {
    staticClass: "border border-dark text-dark text-uppercase mb-2",
    attrs: {
      "variant": "none"
    }
  }, [_vm._v(_vm._s(_vm.form.fleet_ownership === 'own-ship' ? "OWN SHIP" : 'CHARTERED'))])], 1), _vm.form.fleet_ownership ? _c('b-col', {
    attrs: {
      "lg": "6"
    }
  }, [_c('span', [_vm._v("Fleet Type")]), _vm._v(" "), _c('br'), _c('b-badge', {
    staticClass: "border border-dark text-dark text-uppercase mb-2",
    attrs: {
      "variant": "none"
    }
  }, [_vm._v(_vm._s((_vm$detailProjectCont22 = _vm.detailProjectContract) === null || _vm$detailProjectCont22 === void 0 ? void 0 : (_vm$detailProjectCont23 = _vm$detailProjectCont22.fleet_type) === null || _vm$detailProjectCont23 === void 0 ? void 0 : _vm$detailProjectCont23.name))])], 1) : _vm._e()], 1)], 1)]], 2), _vm.form.fleet_type_id && !_vm.form.third_party ? _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [['ADD', 'EDIT'].includes(_vm.action) ? _c('b-row', _vm._l(_vm.form.fleets, function (obj, objIndex) {
    return _c('b-col', {
      key: objIndex,
      attrs: {
        "md": "4"
      }
    }, [_c('div', {
      staticClass: "d-flex mt-2 flex-column w-100"
    }, [_c('strong', {
      staticClass: "text-truncate"
    }, [_vm._v(_vm._s(_vm.showVehicleName(obj.vehicle_id)))]), _c('div', {
      staticClass: "d-flex align-items-center"
    }, [_c('b-button', {
      attrs: {
        "variant": "primary",
        "size": "sm"
      },
      on: {
        "click": function click($event) {
          return _vm.onOpenSlideDetailVehicle(obj.vehicle_id, objIndex, false, null);
        }
      }
    }, [_vm._v(_vm._s(obj.vehicle_id ? 'Change ' : 'Select '))]), obj.vehicle_id ? _c('i', {
      staticClass: "fa fa-trash text-danger border border-danger p-1 rounded-circle ml-2",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function click($event) {
          _vm.form.fleets[objIndex].vehicle_id = null;
        }
      }
    }) : _vm._e()], 1)])]);
  }), 1) : _c('b-row', [_c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_vm._v("Fleets")]), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-warp"
  }, _vm._l(_vm.form.fleets, function (objDetail, detailIndex) {
    return _c('b-badge', {
      key: detailIndex,
      staticClass: "border border-primary text-primary text-uppercase mb-2 mr-2",
      attrs: {
        "variant": "none"
      }
    }, [_vm._v(_vm._s(objDetail.vehicle_name))]);
  }), 1)])], 1)], 1) : _vm._e(), _c('b-col', {
    attrs: {
      "md": _vm.form.third_party ? '8' : '4'
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Collections Of Forms",
      "label-for": "contract"
    }
  }, [['ADD', 'EDIT'].includes(_vm.action) ? [_vm.optionsForms.length > 0 ? _c('v-multiselect', {
    staticClass: "w-100",
    attrs: {
      "options": _vm.optionsForms,
      "multiple": true,
      "group-select": true,
      "placeholder": "Select Forms",
      "track-by": "label",
      "label": "label"
    },
    model: {
      value: _vm.form.project_forms,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "project_forms", $$v);
      },
      expression: "form.project_forms"
    }
  }) : _c('strong', {
    staticClass: "text-muted"
  }, [_vm._v("No forms yet.")])] : [_c('div', {
    staticClass: "d-flex flex-wrap gap-2"
  }, _vm._l(_vm.form.project_forms, function (state, index) {
    return _c('b-badge', {
      key: index,
      staticClass: "border border-primary text-primary text-uppercase m-1",
      attrs: {
        "variant": "none"
      }
    }, [_vm._v(" " + _vm._s(state === null || state === void 0 ? void 0 : state.label) + " ")]);
  }), 1)]], 2)], 1), !_vm.form.fleet_type_id && !_vm.form.third_party ? _c('b-col', {
    attrs: {
      "md": "4"
    }
  }) : _vm._e(), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Periode Start",
      "label-for": "contract"
    }
  }, [['ADD', 'EDIT'].includes(_vm.action) ? _c('b-form-input', {
    attrs: {
      "id": "periode_start",
      "name": "periode_start",
      "type": "date"
    },
    model: {
      value: _vm.form.periode_start,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "periode_start", $$v);
      },
      expression: "form.periode_start"
    }
  }) : _c('strong', [_vm._v(_vm._s((_vm$form = _vm.form) !== null && _vm$form !== void 0 && _vm$form.periode_start ? _vm.moment((_vm$form2 = _vm.form) === null || _vm$form2 === void 0 ? void 0 : _vm$form2.periode_start).format('DD MMMM YYYY') : '-'))])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Periode End",
      "label-for": "contract"
    }
  }, [['ADD', 'EDIT'].includes(_vm.action) ? _c('b-form-input', {
    attrs: {
      "id": "periode_end",
      "name": "periode_end",
      "type": "date"
    },
    model: {
      value: _vm.form.periode_end,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "periode_end", $$v);
      },
      expression: "form.periode_end"
    }
  }) : _c('strong', [_vm._v(_vm._s((_vm$form3 = _vm.form) !== null && _vm$form3 !== void 0 && _vm$form3.periode_start ? _vm.moment((_vm$form4 = _vm.form) === null || _vm$form4 === void 0 ? void 0 : _vm$form4.periode_start).format('DD MMMM YYYY') : '-'))])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Contract Type",
      "label-for": "contract"
    }
  }, [['ADD', 'EDIT'].includes(_vm.action) ? _c('v-multiselect', {
    attrs: {
      "placeholder": "search/add contract",
      "label": "name",
      "track-by": "id",
      "close-on-select": true,
      "clear-on-select": true,
      "options": _vm.optionsContractType,
      "required": ""
    },
    on: {
      "search-change": _vm.searchContractType
    },
    model: {
      value: _vm.form.contract_type_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "contract_type_id", $$v);
      },
      expression: "form.contract_type_id"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    on: {
      "click": _vm.doAddContractType
    },
    slot: "noResult"
  }, [_vm._v(" Not Found. Click to add "), _c('strong', [_vm._v(_vm._s(_vm.contractTypeName))])])]) : _vm._e(), ['ADD', 'EDIT'].includes(_vm.action) && _vm.form.contract_type_id ? _c('span', [_vm._v(_vm._s((_vm$form$contract_typ = _vm.form.contract_type_id) !== null && _vm$form$contract_typ !== void 0 && _vm$form$contract_typ.is_spal ? "Yes, using spal" : 'Not using spal'))]) : _vm._e(), ['PREVIEW'].includes(_vm.action) ? _c('strong', [_vm._v(_vm._s((_vm$detailProjectCont24 = _vm.detailProjectContract) === null || _vm$detailProjectCont24 === void 0 ? void 0 : (_vm$detailProjectCont25 = _vm$detailProjectCont24.contract_type) === null || _vm$detailProjectCont25 === void 0 ? void 0 : _vm$detailProjectCont25.name))]) : _vm._e()], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Cargo Type",
      "label-for": "contract"
    }
  }, [['ADD', 'EDIT'].includes(_vm.action) ? _c('v-select', {
    staticClass: "w-100 mb-2",
    attrs: {
      "label": "text",
      "name": "cargo_type_id",
      "options": _vm.optionsCargoType,
      "reduce": function reduce(optionsCargoType) {
        return optionsCargoType.value;
      },
      "placeholder": "Select...",
      "required": ""
    },
    on: {
      "input": function input($event) {
        _vm.onDataIntoPlan('cargo_type_id', _vm.form.cargo_type_id);
        _vm.onChangeCargoType();
      }
    },
    model: {
      value: _vm.form.cargo_type_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "cargo_type_id", $$v);
      },
      expression: "form.cargo_type_id"
    }
  }) : _c('strong', [_vm._v(_vm._s((_vm$detailProjectCont26 = (_vm$detailProjectCont27 = _vm.detailProjectContract) === null || _vm$detailProjectCont27 === void 0 ? void 0 : (_vm$detailProjectCont28 = _vm$detailProjectCont27.cargo_type) === null || _vm$detailProjectCont28 === void 0 ? void 0 : _vm$detailProjectCont28.name) !== null && _vm$detailProjectCont26 !== void 0 ? _vm$detailProjectCont26 : '-'))])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Terms",
      "label-for": "contract"
    }
  }, [['ADD', 'EDIT'].includes(_vm.action) ? _c('v-select', {
    staticClass: "w-100 mb-1",
    attrs: {
      "label": "text",
      "name": "cargo_type_id",
      "options": _vm.optionsTerms,
      "reduce": function reduce(optionsTerms) {
        return optionsTerms.value;
      },
      "placeholder": "Select..."
    },
    model: {
      value: _vm.form.terms_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "terms_id", $$v);
      },
      expression: "form.terms_id"
    }
  }) : _vm._e(), ['ADD', 'EDIT'].includes(_vm.action) ? _c('b-form-textarea', {
    attrs: {
      "placeholder": "Type Text"
    },
    model: {
      value: _vm.form.terms_remarks,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "terms_remarks", $$v);
      },
      expression: "form.terms_remarks"
    }
  }) : _c('strong', [_vm._v(_vm._s((_vm$detailProjectCont29 = (_vm$detailProjectCont30 = _vm.detailProjectContract) === null || _vm$detailProjectCont30 === void 0 ? void 0 : (_vm$detailProjectCont31 = _vm$detailProjectCont30.terms) === null || _vm$detailProjectCont31 === void 0 ? void 0 : _vm$detailProjectCont31.name) !== null && _vm$detailProjectCont29 !== void 0 ? _vm$detailProjectCont29 : '-') + " "), _c('br'), _vm._v(" Remarks: " + _vm._s(_vm.form.terms_remarks))])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Total Quantity",
      "label-for": "contract"
    }
  }, [_vm.form.cargo_type_id ? _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('strong', {
    staticClass: "mr-2"
  }, [_vm._v(_vm._s((_vm$totalQuantityAdd = _vm.totalQuantityAdd) === null || _vm$totalQuantityAdd === void 0 ? void 0 : _vm$totalQuantityAdd.toLocaleString()))]), _vm.optionUnit.length > 0 && !_vm.unit_others && ['ADD', 'EDIT'].includes(_vm.action) ? _c('v-select', {
    staticClass: "w-100 mb-2",
    attrs: {
      "label": "text",
      "name": "unit",
      "options": _vm.optionUnit,
      "reduce": function reduce(optionUnit) {
        return optionUnit.value;
      },
      "placeholder": "Select..."
    },
    model: {
      value: _vm.form.unit,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "unit", $$v);
      },
      expression: "form.unit"
    }
  }) : _c('strong', [_vm._v(_vm._s(_vm.form.unit))]), _vm.unit_others && ['ADD', 'EDIT'].includes(_vm.action) ? _c('b-form-input', {
    staticClass: "w-50",
    attrs: {
      "size": "sm",
      "placeholder": "Type Text"
    },
    model: {
      value: _vm.form.unit,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "unit", $$v);
      },
      expression: "form.unit"
    }
  }) : _vm._e()], 1) : _c('div', [_c('i', [_vm._v("Choose cargo type first.")])])])], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "POL",
      "label-for": "pol"
    }
  }, [['ADD', 'EDIT'].includes(_vm.action) ? _vm._l(_vm.form.pol, function (obj, polIndex) {
    return _c('div', {
      key: polIndex,
      staticClass: "d-flex align-items-center mb-2"
    }, [_c('v-select', {
      staticClass: "bg-white w-100 mr-2",
      attrs: {
        "label": "text",
        "options": _vm.positionListTextPOL,
        "reduce": function reduce(positionListTextPOL) {
          return positionListTextPOL.value;
        },
        "placeholder": "Select pol"
      },
      on: {
        "input": function input($event) {
          return _vm.onDataIntoPlan('pol', _vm.form.pol);
        }
      },
      model: {
        value: obj.value,
        callback: function callback($$v) {
          _vm.$set(obj, "value", $$v);
        },
        expression: "obj.value"
      }
    }), obj.value === 'Other' ? _c('b-form-input', {
      staticClass: "mr-2",
      attrs: {
        "size": "sm",
        "placeholder": "Type Text"
      },
      model: {
        value: obj.valueOther,
        callback: function callback($$v) {
          _vm.$set(obj, "valueOther", $$v);
        },
        expression: "obj.valueOther"
      }
    }) : _vm._e(), polIndex === 0 ? _c('i', {
      staticClass: "fa fa-plus text-success border border-success p-1 rounded-circle",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function click($event) {
          return _vm.form.pol.push({
            value: '',
            valueOther: ''
          });
        }
      }
    }) : _c('i', {
      staticClass: "fa fa-trash text-danger border border-danger p-1 rounded-circle",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function click($event) {
          return _vm.form.pol.splice(polIndex, 1);
        }
      }
    })], 1);
  }) : [_c('div', {
    staticClass: "d-flex flex-wrap w-100"
  }, _vm._l(_vm.detailProjectContract.pol, function (obj, polIndex) {
    var _obj$value;
    return _c('b-badge', {
      key: polIndex,
      staticClass: "border border-primary text-primary text-uppercase mb-2 mr-2",
      attrs: {
        "variant": "none"
      }
    }, [_vm._v(" " + _vm._s((obj === null || obj === void 0 ? void 0 : obj.value) === "Other" ? obj.valueOther : (_obj$value = obj === null || obj === void 0 ? void 0 : obj.value) !== null && _obj$value !== void 0 ? _obj$value : '-') + " ")]);
  }), 1)]], 2)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "POD",
      "label-for": "pod"
    }
  }, [['ADD', 'EDIT'].includes(_vm.action) ? _vm._l(_vm.form.pod, function (obj, podIndex) {
    return _c('div', {
      key: podIndex,
      staticClass: "d-flex align-items-center mb-2"
    }, [_c('v-select', {
      staticClass: "bg-white w-100 mr-2",
      attrs: {
        "label": "text",
        "options": _vm.positionListTextPOD,
        "reduce": function reduce(positionListTextPOD) {
          return positionListTextPOD.value;
        },
        "placeholder": "Select pol"
      },
      on: {
        "input": function input($event) {
          return _vm.onDataIntoPlan('pod', _vm.form.pod);
        }
      },
      model: {
        value: obj.value,
        callback: function callback($$v) {
          _vm.$set(obj, "value", $$v);
        },
        expression: "obj.value"
      }
    }), obj.value === 'Other' ? _c('b-form-input', {
      staticClass: "mr-2",
      attrs: {
        "size": "sm",
        "placeholder": "Type Text"
      },
      model: {
        value: obj.valueOther,
        callback: function callback($$v) {
          _vm.$set(obj, "valueOther", $$v);
        },
        expression: "obj.valueOther"
      }
    }) : _vm._e(), podIndex === 0 ? _c('i', {
      staticClass: "fa fa-plus text-success border border-success p-1 rounded-circle",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function click($event) {
          return _vm.form.pod.push({
            value: '',
            valueOther: ''
          });
        }
      }
    }) : _c('i', {
      staticClass: "fa fa-trash text-danger border border-danger p-1 rounded-circle",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function click($event) {
          return _vm.form.pod.splice(podIndex, 1);
        }
      }
    })], 1);
  }) : [_c('div', {
    staticClass: "d-flex flex-wrap w-100"
  }, _vm._l(_vm.detailProjectContract.pod, function (obj, podIndex) {
    var _obj$value2;
    return _c('b-badge', {
      key: podIndex,
      staticClass: "border border-primary text-primary text-uppercase mb-2 mr-2",
      attrs: {
        "variant": "none"
      }
    }, [_vm._v(" " + _vm._s((obj === null || obj === void 0 ? void 0 : obj.value) === "Other" ? obj.valueOther : (_obj$value2 = obj === null || obj === void 0 ? void 0 : obj.value) !== null && _obj$value2 !== void 0 ? _obj$value2 : '-') + " ")]);
  }), 1)]], 2)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Laycan",
      "label-for": "laycan"
    }
  }, [['ADD', 'EDIT'].includes(_vm.action) ? _c('date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "range": "",
      "placeholder": "Select date range",
      "format": "DD-MM-YYYY",
      "required": ""
    },
    model: {
      value: _vm.form.laycan,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "laycan", $$v);
      },
      expression: "form.laycan"
    }
  }) : _c('div', {
    staticClass: "d-flex"
  }, [_c('strong', [_vm._v(_vm._s((_vm$form5 = _vm.form) !== null && _vm$form5 !== void 0 && (_vm$form5$laycan = _vm$form5.laycan) !== null && _vm$form5$laycan !== void 0 && _vm$form5$laycan[0] ? _vm.moment((_vm$form6 = _vm.form) === null || _vm$form6 === void 0 ? void 0 : (_vm$form6$laycan = _vm$form6.laycan) === null || _vm$form6$laycan === void 0 ? void 0 : _vm$form6$laycan[0]).format('DD MMM YYYY') : '-'))]), _c('span', {
    staticClass: "mx-2"
  }, [_vm._v("s/d")]), _c('strong', [_vm._v(_vm._s((_vm$form7 = _vm.form) !== null && _vm$form7 !== void 0 && (_vm$form7$laycan = _vm$form7.laycan) !== null && _vm$form7$laycan !== void 0 && _vm$form7$laycan[1] ? _vm.moment((_vm$form8 = _vm.form) === null || _vm$form8 === void 0 ? void 0 : (_vm$form8$laycan = _vm$form8.laycan) === null || _vm$form8$laycan === void 0 ? void 0 : _vm$form8$laycan[1]).format('DD MMM YYYY') : '-'))])])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Distance",
      "label-for": "distance"
    }
  }, [['ADD', 'EDIT'].includes(_vm.action) ? _c('b-form-input', {
    attrs: {
      "id": "distance",
      "name": "distance",
      "placeholder": "Type Number ...",
      "type": "number",
      "required": ""
    },
    model: {
      value: _vm.form.distance,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "distance", $$v);
      },
      expression: "form.distance"
    }
  }) : _vm._e(), ['ADD', 'EDIT'].includes(_vm.action) ? _c('small', [_vm._v(_vm._s(_vm.form.distance ? (_Number = Number(_vm.form.distance)) === null || _Number === void 0 ? void 0 : _Number.toLocaleString() : 0))]) : _c('strong', [_vm._v(_vm._s((_vm$form9 = _vm.form) === null || _vm$form9 === void 0 ? void 0 : (_vm$form9$distance = _vm$form9.distance) === null || _vm$form9$distance === void 0 ? void 0 : _vm$form9$distance.toLocaleString()))])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Currency",
      "label-for": "currency_id"
    }
  }, [['ADD', 'EDIT'].includes(_vm.action) ? _c('v-select', {
    staticClass: "mr-2 w-100",
    staticStyle: {
      "background-color": "#ffffff"
    },
    attrs: {
      "label": "text",
      "options": _vm.optionsCurrency,
      "reduce": function reduce(optionsCurrency) {
        return optionsCurrency.value;
      },
      "placeholder": "Select..."
    },
    model: {
      value: _vm.form.currency_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "currency_id", $$v);
      },
      expression: "form.currency_id"
    }
  }) : _c('strong', [_vm._v(_vm._s((_vm$optionsCurrency = _vm.optionsCurrency) === null || _vm$optionsCurrency === void 0 ? void 0 : (_vm$optionsCurrency$f = _vm$optionsCurrency.find(function (obj) {
    var _vm$form0;
    return obj.value === ((_vm$form0 = _vm.form) === null || _vm$form0 === void 0 ? void 0 : _vm$form0.currency_id);
  })) === null || _vm$optionsCurrency$f === void 0 ? void 0 : _vm$optionsCurrency$f.text))])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [(_vm$form1 = _vm.form) !== null && _vm$form1 !== void 0 && _vm$form1.currency_id && ((_vm$optionsCurrency2 = _vm.optionsCurrency) === null || _vm$optionsCurrency2 === void 0 ? void 0 : (_vm$optionsCurrency2$ = _vm$optionsCurrency2.find(function (obj) {
    return (obj === null || obj === void 0 ? void 0 : obj.value) === _vm.form.currency_id;
  })) === null || _vm$optionsCurrency2$ === void 0 ? void 0 : _vm$optionsCurrency2$.text) !== 'IDR' ? _c('b-form-group', {
    attrs: {
      "label": "Currency Rate",
      "label-for": "currency_rate"
    }
  }, [['ADD', 'EDIT'].includes(_vm.action) ? _c('b-form-input', {
    attrs: {
      "id": "currency_rate",
      "name": "currency_rate",
      "type": "number",
      "placeholder": "0"
    },
    model: {
      value: _vm.form.currency_rate,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "currency_rate", $$v);
      },
      expression: "form.currency_rate"
    }
  }) : _vm._e(), ['ADD', 'EDIT'].includes(_vm.action) ? _c('small', [_vm._v(_vm._s(_vm.formatCurrency(Number(_vm.form.currency_rate))))]) : _c('strong', [_vm._v(_vm._s(_vm.formatCurrency(Number(_vm.form.currency_rate))))])], 1) : _vm._e()], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Freight Rate (Est)",
      "label-for": "shipmentPlanNumber"
    }
  }, [['ADD', 'EDIT'].includes(_vm.action) ? [_c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('b-form-input', {
    staticClass: "mb-2",
    attrs: {
      "id": "freight_rate_est",
      "name": "freight_rate_est",
      "placeholder": "Type Number ...",
      "type": "number",
      "step": ".0001",
      "required": ""
    },
    model: {
      value: _vm.form.freight_rate_est,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "freight_rate_est", $$v);
      },
      expression: "form.freight_rate_est"
    }
  }), ((_vm$optionsCurrency3 = _vm.optionsCurrency) === null || _vm$optionsCurrency3 === void 0 ? void 0 : (_vm$optionsCurrency3$ = _vm$optionsCurrency3.find(function (obj) {
    return (obj === null || obj === void 0 ? void 0 : obj.value) === _vm.form.currency_id;
  })) === null || _vm$optionsCurrency3$ === void 0 ? void 0 : _vm$optionsCurrency3$.text) !== 'IDR' ? _c('small', [_vm._v("$ " + _vm._s((_Number2 = Number(_vm.form.freight_rate_est)) === null || _Number2 === void 0 ? void 0 : _Number2.toLocaleString()))]) : _c('small', [_vm._v(_vm._s(_vm.formatCurrency(_vm.form.freight_rate_est)))]), _c('b-form-radio-group', {
    attrs: {
      "inline": ""
    },
    model: {
      value: _vm.form.ppn,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "ppn", $$v);
      },
      expression: "form.ppn"
    }
  }, [_c('b-form-radio', {
    key: "include",
    attrs: {
      "value": "include",
      "name": "ppn"
    }
  }, [_vm._v("Include PPN")]), _c('b-form-radio', {
    key: "exclude",
    attrs: {
      "value": "exclude",
      "name": "ppn"
    }
  }, [_vm._v("Exclude PPN")])], 1)], 1)] : [_c('div', {
    staticClass: "d-flex flex-column"
  }, [((_vm$optionsCurrency4 = _vm.optionsCurrency) === null || _vm$optionsCurrency4 === void 0 ? void 0 : (_vm$optionsCurrency4$ = _vm$optionsCurrency4.find(function (obj) {
    return (obj === null || obj === void 0 ? void 0 : obj.value) === _vm.form.currency_id;
  })) === null || _vm$optionsCurrency4$ === void 0 ? void 0 : _vm$optionsCurrency4$.text) !== 'IDR' ? _c('strong', [_vm._v("$ " + _vm._s((_Number3 = Number(_vm.form.freight_rate_est)) === null || _Number3 === void 0 ? void 0 : _Number3.toLocaleString()))]) : _c('strong', [_vm._v(_vm._s(_vm.formatCurrency((_vm$detailProjectCont32 = _vm.detailProjectContract) === null || _vm$detailProjectCont32 === void 0 ? void 0 : _vm$detailProjectCont32.freight_rate_est)))]), _c('strong', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.form.ppn == 'include' ? 'Include ' : 'Exclude ') + " PPN")])])]], 2)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Shipment Plan Number",
      "label-for": "shipmentPlanNumber"
    }
  }, [_c('strong', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.shipmentPlanNumber))])])], 1), _c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Remarks",
      "label-for": "remarks"
    }
  }, [['ADD', 'EDIT'].includes(_vm.action) ? _c('b-form-textarea', {
    attrs: {
      "id": "remarks",
      "name": "remarks",
      "placeholder": "Type Text ..."
    },
    model: {
      value: _vm.form.remarks,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "remarks", $$v);
      },
      expression: "form.remarks"
    }
  }) : _c('strong', [_vm._v(_vm._s(_vm.form.remarks))])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-wrap"
  }, [_c('b-form-group', {
    staticClass: "mr-4",
    attrs: {
      "label": "Need More Detail",
      "label-for": "remarks"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "name": "check-button",
      "switch": "",
      "inline": "",
      "disabled": ""
    },
    model: {
      value: _vm.form.need_more_detail,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "need_more_detail", $$v);
      },
      expression: "form.need_more_detail"
    }
  }, [_vm._v(" Yes / No ")])], 1), _c('b-form-group', {
    staticClass: "mr-4",
    attrs: {
      "label": "Need Tender",
      "label-for": "remarks"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "name": "check-button",
      "switch": "",
      "inline": "",
      "disabled": ['PREVIEW'].includes(_vm.action)
    },
    model: {
      value: _vm.form.is_tender,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "is_tender", $$v);
      },
      expression: "form.is_tender"
    }
  }, [_vm._v(" Yes / No ")])], 1), _c('b-form-group', {
    staticClass: "mr-4",
    attrs: {
      "label": "Need Pre-Fixtured Analysis",
      "label-for": "remarks"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "name": "check-button",
      "switch": "",
      "inline": "",
      "disabled": ['PREVIEW'].includes(_vm.action)
    },
    model: {
      value: _vm.form.is_pfa,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "is_pfa", $$v);
      },
      expression: "form.is_pfa"
    }
  }, [_vm._v(" Yes / No ")])], 1), _c('b-form-group', {
    staticClass: "mr-4",
    attrs: {
      "label": "Need Document",
      "label-for": "remarks"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "name": "check-button",
      "switch": "",
      "inline": "",
      "disabled": ['PREVIEW'].includes(_vm.action)
    },
    model: {
      value: _vm.form.need_document,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "need_document", $$v);
      },
      expression: "form.need_document"
    }
  }, [_vm._v(" Yes / No ")])], 1), _c('b-form-group', {
    attrs: {
      "label": "Project need approvals",
      "label-for": "remarks"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "name": "check-button",
      "switch": "",
      "inline": ""
    },
    model: {
      value: _vm.form.need_approval,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "need_approval", $$v);
      },
      expression: "form.need_approval"
    }
  }, [_vm._v(" Yes / No ")])], 1)], 1)]), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_vm.form.need_approval ? _c('b-form-group', {
    attrs: {
      "label": "How much approval is needed?",
      "label-for": "shipmentPlanNumber"
    }
  }, [['ADD'].includes(_vm.action) ? _c('b-form-select', {
    attrs: {
      "plain": "",
      "size": "sm",
      "required": ""
    },
    on: {
      "change": _vm.onChangeManyApproval
    },
    model: {
      value: _vm.form.many_approval,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "many_approval", $$v);
      },
      expression: "form.many_approval"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select values....")]), _c('b-form-select-option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("1")]), _c('b-form-select-option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("2")]), _c('b-form-select-option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("3")]), _c('b-form-select-option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("4")])], 1) : _c('strong', [_vm._v(_vm._s(_vm.form.many_approval) + " Approvals")])], 1) : _vm._e()], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_vm.form.many_approval && _vm.form.need_approval ? _c('b-form-group', {
    attrs: {
      "label": "Users Approval",
      "label-for": "shipmentPlanNumber"
    }
  }, [['ADD', 'EDIT'].includes(_vm.action) ? _vm._l(_vm.form.user_approval, function (user, userIndex) {
    return _c('div', {
      key: userIndex,
      staticClass: "d-flex align-items-center mb-2"
    }, [_c('strong', [_vm._v(_vm._s(userIndex + 1) + ". ")]), _c('v-select', {
      staticClass: "w-100 ml-2",
      attrs: {
        "label": "text",
        "name": "user",
        "options": _vm.optionsExpertUsers,
        "reduce": function reduce(optionsExpertUsers) {
          return optionsExpertUsers.value;
        },
        "placeholder": "Select User",
        "required": ""
      },
      model: {
        value: user.user,
        callback: function callback($$v) {
          _vm.$set(user, "user", $$v);
        },
        expression: "user.user"
      }
    })], 1);
  }) : _vm._l((_vm$detailProjectCont33 = _vm.detailProjectContract) === null || _vm$detailProjectCont33 === void 0 ? void 0 : _vm$detailProjectCont33.user_approval, function (user, userIndex) {
    return _c('div', {
      key: userIndex,
      staticClass: "d-flex align-items-center mb-2"
    }, [_c('strong', {
      staticClass: "mr-2"
    }, [_vm._v(_vm._s(userIndex + 1) + ".")]), _c('strong', [_vm._v(_vm._s(user === null || user === void 0 ? void 0 : user.name))])]);
  })], 2) : _vm._e()], 1)], 1)], 1)]) : _vm._e(), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('b-row', [_vm.form.is_tender && _vm.form.customer_id && _vm.form.project_sub_id || _vm.form.is_tender && _vm.form.customer_id ? _c('b-col', {
    attrs: {
      "lg": "6"
    }
  }, [_c('fieldset', {
    staticClass: "form-group border p-3"
  }, [_c('legend', {
    staticClass: "w-auto px-2 text-primary"
  }, [_vm._v("Tender Form")]), _c('div', {
    staticClass: "d-flex w-100 mb-2 justify-content-end"
  }, [['EDIT'].includes(_vm.action) ? _c('b-button', {
    attrs: {
      "type": "button",
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        _vm.editTender = !_vm.editTender;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pen"
  })]) : _vm._e()], 1), _c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("PIC")]), _c('td', {
    attrs: {
      "width": "5%"
    }
  }, [_vm._v(":")]), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [['ADD'].includes(_vm.action) && !_vm.editTender || ['EDIT'].includes(_vm.action) && _vm.editTender ? _c('b-form-input', {
    attrs: {
      "placeholder": "Type Text",
      "required": ""
    },
    model: {
      value: _vm.form.formTender.pic,
      callback: function callback($$v) {
        _vm.$set(_vm.form.formTender, "pic", $$v);
      },
      expression: "form.formTender.pic"
    }
  }) : _c('span', [_vm._v(_vm._s((_vm$form10 = _vm.form) === null || _vm$form10 === void 0 ? void 0 : (_vm$form10$formTender = _vm$form10.formTender) === null || _vm$form10$formTender === void 0 ? void 0 : _vm$form10$formTender.pic))])], 1), _c('th', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("Url")]), _c('td', {
    attrs: {
      "width": "5%"
    }
  }, [_vm._v(":")]), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [['ADD'].includes(_vm.action) && !_vm.editTender || ['EDIT'].includes(_vm.action) && _vm.editTender ? _c('b-form-input', {
    attrs: {
      "placeholder": "Type Text",
      "required": ""
    },
    model: {
      value: _vm.form.formTender.url,
      callback: function callback($$v) {
        _vm.$set(_vm.form.formTender, "url", $$v);
      },
      expression: "form.formTender.url"
    }
  }) : _c('span', [_vm._v(_vm._s((_vm$form$formTender = _vm.form.formTender) === null || _vm$form$formTender === void 0 ? void 0 : _vm$form$formTender.url))])], 1)]), _c('tr', [_c('th', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("Description")]), _c('td', {
    attrs: {
      "width": "5%"
    }
  }, [_vm._v(":")]), _c('td', {
    attrs: {
      "colSpan": "4"
    }
  }, [['ADD'].includes(_vm.action) && !_vm.editTender || ['EDIT'].includes(_vm.action) && _vm.editTender ? _c('b-form-textarea', {
    attrs: {
      "placeholder": "Type Text",
      "required": ""
    },
    model: {
      value: _vm.form.formTender.description_of_tender,
      callback: function callback($$v) {
        _vm.$set(_vm.form.formTender, "description_of_tender", $$v);
      },
      expression: "form.formTender.description_of_tender"
    }
  }) : _c('span', [_vm._v(_vm._s((_vm$form$formTender2 = _vm.form.formTender) === null || _vm$form$formTender2 === void 0 ? void 0 : _vm$form$formTender2.description_of_tender))])], 1)]), _c('tr', [_c('th', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("File")]), _c('td', {
    attrs: {
      "width": "5%"
    }
  }, [_vm._v(":")]), _c('td', {
    attrs: {
      "colSpan": "4"
    }
  }, [['ADD'].includes(_vm.action) && !_vm.editTender || ['EDIT'].includes(_vm.action) && _vm.editTender ? _c('b-form-file', {
    staticClass: "form-control",
    attrs: {
      "plain": "",
      "id": "file",
      "accept": "application/*",
      "multiple": ""
    },
    model: {
      value: _vm.form.formTender.file,
      callback: function callback($$v) {
        _vm.$set(_vm.form.formTender, "file", $$v);
      },
      expression: "form.formTender.file"
    }
  }) : _c('div', {
    staticClass: "d-flex align-items-center flex-wrap"
  }, _vm._l((_vm$detailProjectCont34 = _vm.detailProjectContract) === null || _vm$detailProjectCont34 === void 0 ? void 0 : (_vm$detailProjectCont35 = _vm$detailProjectCont34.project_tender) === null || _vm$detailProjectCont35 === void 0 ? void 0 : _vm$detailProjectCont35.file, function (tender, tenderIndex) {
    return _c('img', {
      key: tenderIndex,
      staticStyle: {
        "width": "40px",
        "height": "40px",
        "cursor": "pointer"
      },
      attrs: {
        "src": require("../../../assets/images/activity/pdf.png"),
        "alt": "img-image"
      },
      on: {
        "click": function click($event) {
          return _vm.handleOpenFilePreview("".concat(_vm.apiUrl, "/").concat(tender.url), 'tender');
        }
      }
    });
  }), 0)], 1)])])])])]) : _vm._e(), _vm.form.need_document && _vm.form.customer_id && _vm.form.project_sub_id && _vm.project_type === 'existing' || _vm.form.need_document && _vm.form.customer_id && _vm.project_type === 'new_project' || _vm.form.new_project_id && _vm.form.sub_project_name && _vm.form.customer_id && _vm.project_type === 'existing' ? _c('b-col', {
    attrs: {
      "lg": "6"
    }
  }, [_c('fieldset', {
    staticClass: "form-group border p-3"
  }, [_c('legend', {
    staticClass: "w-auto px-2 text-primary"
  }, [_vm._v("Document Attachment")]), _c('div', {
    staticClass: "d-flex w-100 mb-2 justify-content-end"
  }, [['EDIT'].includes(_vm.action) ? _c('b-button', {
    attrs: {
      "type": "button",
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        _vm.editDocument = !_vm.editDocument;
      }
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-pen"
  })])]) : _vm._e()], 1), _c('div', {
    staticClass: "overflow-auto",
    staticStyle: {
      "max-height": "300px"
    }
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "vertical-align": "middle",
      "width": "20px"
    }
  }, [_vm._v("NO")]), _c('th', {
    staticClass: "text-truncate text-center",
    staticStyle: {
      "vertical-align": "middle",
      "width": "250px"
    }
  }, [_vm._v("Name of File / Document")]), _c('th', {
    staticClass: "text-truncate text-center"
  }, [_vm._v("File / Document")]), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "vertical-align": "middle",
      "width": "20px"
    }
  }, [_vm._v("#")])])]), ['ADD'].includes(_vm.action) && !_vm.editDocument || ['EDIT'].includes(_vm.action) && _vm.editDocument ? _c('tbody', _vm._l(_vm.form.form_document, function (state, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center align-top"
    }, [_vm._v(_vm._s(index + 1))]), _c('td', {
      staticClass: "align-top"
    }, [_c('b-form-input', {
      attrs: {
        "placeholder": "Name of File",
        "required": ""
      },
      model: {
        value: state.filename,
        callback: function callback($$v) {
          _vm.$set(state, "filename", $$v);
        },
        expression: "state.filename"
      }
    })], 1), _c('td', [_c('b-form-file', {
      attrs: {
        "required": state !== null && state !== void 0 && state.url ? false : true,
        "id": 'fileSupport' + index,
        "placeholder": "Choose a file",
        "accept": "application/pdf"
      },
      model: {
        value: state.file,
        callback: function callback($$v) {
          _vm.$set(state, "file", $$v);
        },
        expression: "state.file"
      }
    }), state !== null && state !== void 0 && state.url ? _c('span', {
      staticClass: "text-primary",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function click($event) {
          return _vm.handleOpenFilePreview("".concat(_vm.apiUrl, "/").concat(state === null || state === void 0 ? void 0 : state.url), state === null || state === void 0 ? void 0 : state.filename);
        }
      }
    }, [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : state.filename) + "." + _vm._s(state === null || state === void 0 ? void 0 : state.extension))]) : _vm._e()], 1), _c('td', {
      staticClass: "text-center align-top"
    }, [index !== 0 ? _c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "danger"
      },
      on: {
        "click": function click($event) {
          return _vm.form.form_document.splice(index, 1);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash pr-0"
    })]) : _vm._e()], 1)]);
  }), 0) : _c('tbody', _vm._l((_vm$detailProjectCont36 = _vm.detailProjectContract) === null || _vm$detailProjectCont36 === void 0 ? void 0 : _vm$detailProjectCont36.project_document, function (state, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center align-top"
    }, [_vm._v(_vm._s(index + 1))]), _c('td', [_c('span', [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : state.filename))])]), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticClass: "text-primary",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function click($event) {
          return _vm.handleOpenFilePreview("".concat(_vm.apiUrl, "/").concat(state === null || state === void 0 ? void 0 : state.url), state === null || state === void 0 ? void 0 : state.filename);
        }
      }
    }, [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : state.filename) + "." + _vm._s(state === null || state === void 0 ? void 0 : state.extension))])]), _c('td')]);
  }), 0)])]), ['ADD'].includes(_vm.action) && !_vm.editDocument || ['EDIT'].includes(_vm.action) && _vm.editDocument ? _c('b-button', {
    attrs: {
      "block": "",
      "variant": "success"
    },
    on: {
      "click": function click($event) {
        return _vm.addFormDocument();
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus pr-0"
  }), _vm._v(" ADD MORE ATTACHMENT")]) : _vm._e()], 1)]) : _vm._e()], 1)], 1)], 1)], 1), _vm.form.need_more_detail && _vm.form.customer_id && _vm.form.project_sub_id && _vm.project_type === 'existing' || _vm.form.need_more_detail && _vm.form.customer_id && _vm.project_type === 'new_project' || _vm.form.new_project_id && _vm.form.sub_project_name && _vm.form.customer_id && _vm.project_type === 'existing' ? _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('fieldset', {
    staticClass: "form-group border p-3"
  }, [_c('legend', {
    staticClass: "w-auto px-2 text-primary"
  }, [_vm._v("Detail Project Contract Plan")]), _c('div', {
    staticClass: "d-flex w-100 overflow-auto",
    staticStyle: {
      "max-height": "1000px"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-xs"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center text-truncate align-middle",
    staticStyle: {
      "width": "5px"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("#")]), _c('th', {
    staticClass: "text-center text-truncate align-middle",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("*SHIPMENT PLAN DETAIL NUMBER")]), _c('th', {
    staticClass: "text-center text-truncate align-middle",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("*DESCRIPTION")]), _c('th', {
    staticClass: "text-center text-truncate",
    attrs: {
      "colspan": !_vm.form.third_party ? '3' : '2'
    }
  }, [_vm._v("FLEET")]), _c('th', {
    staticClass: "text-center text-truncate",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("CARGO TYPE")]), _c('th', {
    staticClass: "text-center text-truncate align-middle",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("DRAUGHT TYPE")]), _c('th', {
    staticClass: "text-center text-truncate",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("LOCATION")]), _c('th', {
    staticClass: "text-center text-truncate align-middle",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("SHIPMENT MONTH")]), _c('th', {
    staticClass: "text-center text-truncate",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("PLAN DATE")]), _c('th', {
    staticClass: "text-center text-truncate align-middle",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("*PLAN QUANTITY")]), _c('th', {
    staticClass: "text-center text-truncate align-middle",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("REMARKS")])]), _c('tr', [_c('th', {
    staticClass: "text-center text-truncate"
  }, [_vm._v("*OWNERSHIP")]), _c('th', {
    staticClass: "text-center text-truncate"
  }, [_vm._v("*TYPE")]), !_vm.form.third_party ? _c('th', {
    staticClass: "text-center text-truncate"
  }, [_vm._v("*FLEETS")]) : _vm._e(), _c('th', {
    staticClass: "text-center text-truncate"
  }, [_vm._v("*TYPE")]), _c('th', {
    staticClass: "text-center text-truncate"
  }, [_vm._v("ACC. DATE")]), _c('th', {
    staticClass: "text-center text-truncate"
  }, [_vm._v("*TERMS")]), _c('th', {
    staticClass: "text-center text-truncate"
  }, [_vm._v("POL")]), _c('th', {
    staticClass: "text-center text-truncate"
  }, [_vm._v("POD")]), _c('th', {
    staticClass: "text-center text-truncate"
  }, [_vm._v("ETA POL")]), _c('th', {
    staticClass: "text-center text-truncate"
  }, [_vm._v("ETA POD")])])]), ['ADD', 'EDIT'].includes(_vm.action) ? _c('tbody', _vm._l(_vm.form.detail_plan, function (state, index) {
    var _attrs, _attrs2;
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center align-top"
    }, [index !== 0 ? _c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "danger"
      },
      on: {
        "click": function click($event) {
          return _vm.form.detail_plan.splice(index, 1);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash pr-0"
    })]) : _vm._e()], 1), _c('td', {
      staticClass: "text-center text-truncate align-top"
    }, [_c('span', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(_vm.shipmentPlanNumber + "-".concat(_vm.formatNumber(index + 1))))])]), _c('td', {
      staticClass: "text-center align-top"
    }, [_c('b-form-textarea', {
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "placeholder": "Type Text",
        "type": "text",
        "id": "description",
        "name": "description",
        "size": "sm",
        "rows": "4"
      },
      model: {
        value: state.description,
        callback: function callback($$v) {
          _vm.$set(state, "description", $$v);
        },
        expression: "state.description"
      }
    })], 1), _c('td', {
      staticClass: "text-left align-top"
    }, [_c('b-form-select', {
      staticClass: "form-control",
      staticStyle: {
        "width": "200px"
      },
      attrs: (_attrs = {
        "plain": "",
        "required": "",
        "name": "fleet_ownership"
      }, _attrs["required"] = "", _attrs),
      on: {
        "change": function change($event) {
          return _vm.onChangeOwnership(state.fleet_ownership);
        }
      },
      model: {
        value: state.fleet_ownership,
        callback: function callback($$v) {
          _vm.$set(state, "fleet_ownership", $$v);
        },
        expression: "state.fleet_ownership"
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("Select ownership...")]), _c('option', {
      attrs: {
        "value": "own-ship"
      }
    }, [_vm._v("OWN SHIP")]), _c('option', {
      attrs: {
        "value": "chartered"
      }
    }, [_vm._v("CHARTERED")])])], 1), _c('td', {
      staticClass: "text-left align-top"
    }, [_c('b-form-select', {
      staticClass: "form-control",
      staticStyle: {
        "width": "200px"
      },
      attrs: (_attrs2 = {
        "required": "",
        "plain": "",
        "options": _vm.optionsFleetTypes
      }, _attrs2["required"] = "", _attrs2["name"] = "fleet_type_id", _attrs2),
      on: {
        "change": function change($event) {
          return _vm.onChangeFleetType(true, state.fleet_type_id, index);
        }
      },
      scopedSlots: _vm._u([{
        key: "first",
        fn: function fn() {
          return [_c('b-form-select-option', {
            attrs: {
              "value": null
            }
          }, [_vm._v("Select fleet type...")])];
        },
        proxy: true
      }], null, true),
      model: {
        value: state.fleet_type_id,
        callback: function callback($$v) {
          _vm.$set(state, "fleet_type_id", $$v);
        },
        expression: "state.fleet_type_id"
      }
    })], 1), !_vm.form.third_party ? _c('td', {
      staticClass: "text-left align-top"
    }, [state.fleet_type_id ? _c('b-row', _vm._l(state.fleets, function (objDetail, detailIndex) {
      return _c('b-col', {
        key: detailIndex,
        attrs: {
          "md": "12"
        }
      }, [_c('div', {
        staticClass: "d-flex mt-2 flex-column w-100"
      }, [_c('strong', {
        staticClass: "text-truncate"
      }, [_vm._v(_vm._s(_vm.showVehicleName(objDetail.vehicle_id)))]), _c('div', {
        staticClass: "d-flex align-items-center"
      }, [_c('b-button', {
        attrs: {
          "variant": "primary",
          "size": "sm"
        },
        on: {
          "click": function click($event) {
            return _vm.onOpenSlideDetailVehicle(objDetail === null || objDetail === void 0 ? void 0 : objDetail.vehicle_id, detailIndex, true, index);
          }
        }
      }, [_vm._v(_vm._s(objDetail.vehicle_id ? 'Change ' : 'Select '))]), objDetail.vehicle_id ? _c('i', {
        staticClass: "fa fa-trash text-danger border border-danger p-1 rounded-circle ml-2",
        staticStyle: {
          "cursor": "pointer"
        },
        on: {
          "click": function click($event) {
            _vm.form.detail_plan[index].fleets[detailIndex].vehicle_id = null;
          }
        }
      }) : _vm._e()], 1)])]);
    }), 1) : _vm._e()], 1) : _vm._e(), _c('td', {
      staticClass: "text-left align-top"
    }, [_c('v-select', {
      staticClass: "mb-2",
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "label": "text",
        "name": "cargo_type_id",
        "options": _vm.optionsCargoType,
        "reduce": function reduce(optionsCargoType) {
          return optionsCargoType.value;
        },
        "placeholder": "Select User"
      },
      model: {
        value: state.cargo_type_id,
        callback: function callback($$v) {
          _vm.$set(state, "cargo_type_id", $$v);
        },
        expression: "state.cargo_type_id"
      }
    })], 1), _c('td', {
      staticClass: "text-left align-top"
    }, [_c('date-picker', {
      staticClass: "custom-date-picker",
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "value-type": "YYYY-MM-DD HH:mm",
        "type": "datetime",
        "placeholder": "Select date",
        "format": "DD-MM-YYYY HH:mm"
      },
      model: {
        value: state.acceptance_date,
        callback: function callback($$v) {
          _vm.$set(state, "acceptance_date", $$v);
        },
        expression: "state.acceptance_date"
      }
    })], 1), _c('td', {
      staticClass: "text-left align-top"
    }, [_c('b-form-group', {
      staticClass: "d-flex flex-column"
    }, [_c('b-form-select', {
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "required": "",
        "plain": "",
        "size": "sm",
        "options": _vm.optionsProjectTerms
      },
      model: {
        value: state.terms_id,
        callback: function callback($$v) {
          _vm.$set(state, "terms_id", $$v);
        },
        expression: "state.terms_id"
      }
    }, [_c('b-form-select-option', {
      attrs: {
        "value": null
      }
    }, [_vm._v("Select Term")])], 1), _c('b-form-textarea', {
      staticClass: "mt-2",
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "rows": "2",
        "placeholder": "Text Type"
      },
      model: {
        value: state.terms_remarks,
        callback: function callback($$v) {
          _vm.$set(state, "terms_remarks", $$v);
        },
        expression: "state.terms_remarks"
      }
    })], 1)], 1), _c('td', {
      staticClass: "text-left align-top"
    }, [_c('b-form-select', {
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "plain": "",
        "size": "sm"
      },
      model: {
        value: state.draught_type,
        callback: function callback($$v) {
          _vm.$set(state, "draught_type", $$v);
        },
        expression: "state.draught_type"
      }
    }, [_c('b-form-select-option', {
      attrs: {
        "value": "draught_survey_loading"
      }
    }, [_vm._v("Draught Survey Loading")]), _c('b-form-select-option', {
      attrs: {
        "value": "draught_survey_discharge"
      }
    }, [_vm._v("Draught Survey Discharge")])], 1)], 1), _c('td', {
      staticClass: "text-left align-top"
    }, [_vm._l(state.pol, function (obj, polIndex) {
      return _c('div', {
        key: polIndex,
        staticClass: "d-flex align-items-center mb-2 w-100"
      }, [_c('v-select', {
        staticClass: "mr-2",
        staticStyle: {
          "background-color": "#ffffff",
          "width": "200px"
        },
        attrs: {
          "label": "text",
          "options": _vm.positionListTextPOL,
          "reduce": function reduce(positionListTextPOL) {
            return positionListTextPOL.value;
          },
          "placeholder": "Select pol"
        },
        model: {
          value: _vm.form.detail_plan[index].pol[polIndex].value,
          callback: function callback($$v) {
            _vm.$set(_vm.form.detail_plan[index].pol[polIndex], "value", $$v);
          },
          expression: "form.detail_plan[index].pol[polIndex].value"
        }
      }), obj.value === 'Other' ? _c('b-form-input', {
        staticClass: "mr-2",
        staticStyle: {
          "width": "200px"
        },
        attrs: {
          "size": "sm",
          "placeholder": "Type Text"
        },
        model: {
          value: _vm.form.detail_plan[index].pol[polIndex].valueOther,
          callback: function callback($$v) {
            _vm.$set(_vm.form.detail_plan[index].pol[polIndex], "valueOther", $$v);
          },
          expression: "form.detail_plan[index].pol[polIndex].valueOther"
        }
      }) : _vm._e(), polIndex === 0 ? _c('i', {
        staticClass: "fa fa-plus text-success border border-success p-1 rounded-circle",
        staticStyle: {
          "cursor": "pointer"
        },
        on: {
          "click": function click($event) {
            return state.pol.push({
              value: '',
              valueOther: ''
            });
          }
        }
      }) : _c('i', {
        staticClass: "fa fa-trash text-danger border border-danger p-1 rounded-circle",
        staticStyle: {
          "cursor": "pointer"
        },
        on: {
          "click": function click($event) {
            return state.pol.splice(polIndex, 1);
          }
        }
      })], 1);
    })], 2), _c('td', {
      staticClass: "text-left align-top"
    }, [_vm._l(state.pod, function (obj, podIndex) {
      return _c('div', {
        key: podIndex,
        staticClass: "d-flex align-items-center mb-2 w-100"
      }, [_c('v-select', {
        staticClass: "mr-2",
        staticStyle: {
          "background-color": "#ffffff",
          "width": "200px"
        },
        attrs: {
          "label": "text",
          "options": _vm.positionListTextPOD,
          "reduce": function reduce(positionListTextPOD) {
            return positionListTextPOD.value;
          },
          "placeholder": "Select pol"
        },
        model: {
          value: _vm.form.detail_plan[index].pod[podIndex].value,
          callback: function callback($$v) {
            _vm.$set(_vm.form.detail_plan[index].pod[podIndex], "value", $$v);
          },
          expression: "form.detail_plan[index].pod[podIndex].value"
        }
      }), obj.value === 'Other' ? _c('b-form-input', {
        staticClass: "mr-2",
        staticStyle: {
          "width": "200px"
        },
        attrs: {
          "size": "sm",
          "placeholder": "Type Text"
        },
        model: {
          value: obj.valueOther,
          callback: function callback($$v) {
            _vm.$set(obj, "valueOther", $$v);
          },
          expression: "obj.valueOther"
        }
      }) : _vm._e(), podIndex === 0 ? _c('i', {
        staticClass: "fa fa-plus text-success border border-success p-1 rounded-circle",
        staticStyle: {
          "cursor": "pointer"
        },
        on: {
          "click": function click($event) {
            return state.pod.push({
              value: '',
              valueOther: ''
            });
          }
        }
      }) : _c('i', {
        staticClass: "fa fa-trash text-danger border border-danger p-1 rounded-circle",
        staticStyle: {
          "cursor": "pointer"
        },
        on: {
          "click": function click($event) {
            return state.pod.splice(podIndex, 1);
          }
        }
      })], 1);
    })], 2), _c('td', {
      staticClass: "text-left align-top"
    }, [_c('b-form-select', {
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "plain": "",
        "size": "sm"
      },
      model: {
        value: state.shipment,
        callback: function callback($$v) {
          _vm.$set(state, "shipment", $$v);
        },
        expression: "state.shipment"
      }
    }, [_c('b-form-select-option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("SELECT MONTH")]), _c('b-form-select-option', {
      attrs: {
        "value": "JANUARY"
      }
    }, [_vm._v("JANUARI")]), _c('b-form-select-option', {
      attrs: {
        "value": "FEBRUARI"
      }
    }, [_vm._v("FEBRUARI")]), _c('b-form-select-option', {
      attrs: {
        "value": "MARET"
      }
    }, [_vm._v("MARET")]), _c('b-form-select-option', {
      attrs: {
        "value": "APRIL"
      }
    }, [_vm._v("APRIL")]), _c('b-form-select-option', {
      attrs: {
        "value": "MEI"
      }
    }, [_vm._v("MEI")]), _c('b-form-select-option', {
      attrs: {
        "value": "JUNI"
      }
    }, [_vm._v("JUNI")]), _c('b-form-select-option', {
      attrs: {
        "value": "JULI"
      }
    }, [_vm._v("JULI")]), _c('b-form-select-option', {
      attrs: {
        "value": "AGUSTUS"
      }
    }, [_vm._v("AGUSTUS")]), _c('b-form-select-option', {
      attrs: {
        "value": "SEPTEMBER"
      }
    }, [_vm._v("SEPTEMBER")]), _c('b-form-select-option', {
      attrs: {
        "value": "OKTOBER"
      }
    }, [_vm._v("OKTOBER")]), _c('b-form-select-option', {
      attrs: {
        "value": "NOVEMBER"
      }
    }, [_vm._v("NOVEMBER")]), _c('b-form-select-option', {
      attrs: {
        "value": "DESEMBER"
      }
    }, [_vm._v("DESEMBER")])], 1)], 1), _c('td', {
      staticClass: "text-left align-top"
    }, [_c('b-form-input', {
      staticClass: "mb-1",
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "type": "date",
        "id": "eta_pol",
        "size": "sm"
      },
      model: {
        value: state.eta_pol,
        callback: function callback($$v) {
          _vm.$set(state, "eta_pol", $$v);
        },
        expression: "state.eta_pol"
      }
    })], 1), _c('td', {
      staticClass: "text-left align-top"
    }, [_c('b-form-input', {
      staticClass: "mb-1",
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "type": "date",
        "id": "eta_pod",
        "size": "sm"
      },
      model: {
        value: state.eta_pod,
        callback: function callback($$v) {
          _vm.$set(state, "eta_pod", $$v);
        },
        expression: "state.eta_pod"
      }
    })], 1), _c('td', {
      staticClass: "text-left align-top"
    }, [_c('InputCurrency', {
      attrs: {
        "id": "plan_quantity",
        "prepend": "",
        "size": "sm",
        "placeholder": "0",
        "required": ""
      },
      model: {
        value: state.plan_quantity,
        callback: function callback($$v) {
          _vm.$set(state, "plan_quantity", $$v);
        },
        expression: "state.plan_quantity"
      }
    })], 1), _c('td', {
      staticClass: "text-left align-top"
    }, [_c('b-form-textarea', {
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "rows": "4",
        "placeholder": "Comments if any / Komentar jika ada",
        "name": "remarks"
      },
      model: {
        value: state.remarks,
        callback: function callback($$v) {
          _vm.$set(state, "remarks", $$v);
        },
        expression: "state.remarks"
      }
    })], 1)]);
  }), 0) : _c('tbody', _vm._l((_vm$detailProjectCont37 = _vm.detailProjectContract) === null || _vm$detailProjectCont37 === void 0 ? void 0 : _vm$detailProjectCont37.project_contract_plan, function (state, index) {
    var _state$fleet_type, _state$cargo_type, _state$terms;
    return _c('tr', {
      key: index
    }, [_c('th', {
      staticClass: "text-center bg-white text-black"
    }), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : state.shipment_plan_detail_number))]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : state.description))]), _c('td', {
      staticClass: "text-truncate"
    }, [_c('b-badge', {
      staticClass: "border border-dark text-dark text-uppercase mb-2",
      attrs: {
        "variant": "none"
      }
    }, [_vm._v(_vm._s(state.fleet_ownership === 'own-ship' ? "OWN SHIP" : 'CHARTERED'))])], 1), _c('td', {
      staticClass: "text-truncate"
    }, [_c('b-badge', {
      staticClass: "border border-dark text-dark text-uppercase mb-2",
      attrs: {
        "variant": "none"
      }
    }, [_vm._v(_vm._s((_state$fleet_type = state.fleet_type) === null || _state$fleet_type === void 0 ? void 0 : _state$fleet_type.name))])], 1), !_vm.detailProjectContract.third_party ? _c('td', {
      staticClass: "text-truncate"
    }, [_c('div', {
      staticClass: "d-flex"
    }, [_vm._l(state.fleets, function (objDetail, detailIndex) {
      return [objDetail.vehicle_id ? _c('b-badge', {
        key: detailIndex,
        staticClass: "border border-primary text-primary text-uppercase mb-2 mr-2",
        attrs: {
          "variant": "none"
        }
      }, [_vm._v(_vm._s(_vm.showVehicleName(objDetail.vehicle_id)))]) : _vm._e()];
    })], 2)]) : _vm._e(), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : (_state$cargo_type = state.cargo_type) === null || _state$cargo_type === void 0 ? void 0 : _state$cargo_type.name))]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(_vm._s(state !== null && state !== void 0 && state.acceptance_date ? _vm.moment(state === null || state === void 0 ? void 0 : state.acceptance_date).format('DD MMM YYYY HH:mm') : '-'))]), _c('td', {
      staticClass: "text-truncate"
    }, [_c('div', {
      staticClass: "d-flex flex-column"
    }, [_c('span', [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : (_state$terms = state.terms) === null || _state$terms === void 0 ? void 0 : _state$terms.name))]), _c('span', [_vm._v("Remarks: " + _vm._s(state === null || state === void 0 ? void 0 : state.terms_remarks))])])]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(_vm._s(_vm.capitalizeString(state === null || state === void 0 ? void 0 : state.draught_type)))]), _c('td', {
      staticClass: "text-truncate"
    }, [_c('div', {
      staticClass: "d-flex w-100"
    }, _vm._l(state.pol, function (obj, polIndex) {
      var _obj$value3;
      return _c('b-badge', {
        key: polIndex,
        staticClass: "border border-primary text-primary text-uppercase mb-2 mr-2",
        attrs: {
          "variant": "none"
        }
      }, [_vm._v(" " + _vm._s((obj === null || obj === void 0 ? void 0 : obj.value) === "Other" ? obj.valueOther : (_obj$value3 = obj === null || obj === void 0 ? void 0 : obj.value) !== null && _obj$value3 !== void 0 ? _obj$value3 : '-') + " ")]);
    }), 1)]), _c('td', {
      staticClass: "text-truncate"
    }, [_c('div', {
      staticClass: "d-flex w-100"
    }, _vm._l(state.pod, function (obj, podIndex) {
      var _obj$value4;
      return _c('b-badge', {
        key: podIndex,
        staticClass: "border border-primary text-primary text-uppercase mb-2 mr-2",
        attrs: {
          "variant": "none"
        }
      }, [_vm._v(" " + _vm._s((obj === null || obj === void 0 ? void 0 : obj.value) === "Other" ? obj.valueOther : (_obj$value4 = obj === null || obj === void 0 ? void 0 : obj.value) !== null && _obj$value4 !== void 0 ? _obj$value4 : '-') + " ")]);
    }), 1)]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : state.shipment))]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(_vm._s(state.eta_pol ? _vm.moment(state.eta_pol).format('DD MMM YYYY') : '-'))]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(_vm._s(state.eta_pod ? _vm.moment(state.eta_pod).format('DD MMM YYYY') : '-'))]), _c('td', {
      staticClass: "text-truncate text-right"
    }, [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : state.plan_quantity.toLocaleString()))]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : state.remarks))])]);
  }), 0)])]), ['ADD', 'EDIT'].includes(_vm.action) ? _c('b-button', {
    attrs: {
      "block": "",
      "variant": "success"
    },
    on: {
      "click": function click($event) {
        return _vm.addDetailPlanData(false);
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus pr-0"
  }), _vm._v(" ADD MORE PLAN")]) : _vm._e()], 1)]) : _vm._e(), ['ADD'].includes(_vm.action) ? _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center justify-content-end w-100"
  }, [_c('b-button', {
    staticStyle: {
      "width": "15%"
    },
    attrs: {
      "disabled": _vm.saving,
      "block": "",
      "variant": "primary",
      "type": "submit"
    }
  }, [_vm.saving ? _c('span', {
    staticClass: "spinner-border spinner-border-sm"
  }) : _c('div', [_c('i', {
    staticClass: "fa fa-save"
  }), _c('span', [_vm._v("Submit Data")])])])], 1)]) : _vm._e(), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-sidebar', {
    attrs: {
      "id": "detail_vehicle",
      "title": "Detail Fleet",
      "width": "100%",
      "backdrop-variant": "dark",
      "bg-variant": "white",
      "right": "",
      "backdrop": "",
      "shadow": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref3) {
        var hide = _ref3.hide;
        return [_c('SlidePreviewDetailVehicle', {
          attrs: {
            "existedFleet": _vm.form.fleets,
            "options-fleets": _vm.optionsFilteredFleets,
            "fleet": _vm.selectedFleet,
            "fleet-type-id": _vm.form.fleet_type_id,
            "ownership": _vm.form.fleet_ownership,
            "on-open-slide-detail-vehicle": _vm.onOpenSlideDetailVehicle
          },
          on: {
            "updateVehicleId": _vm.updateVehicleId
          }
        })];
      }
    }], null, false, 3862566193),
    model: {
      value: _vm.slidePreviewDetailVehicle,
      callback: function callback($$v) {
        _vm.slidePreviewDetailVehicle = $$v;
      },
      expression: "slidePreviewDetailVehicle"
    }
  })], 1)], 1) : _vm._e(), _vm.activeTab === 2 ? _c('div', {
    attrs: {
      "id": "form-list"
    }
  }, [_c('SlideProjectForms', {
    attrs: {
      "form-id": (_vm$detailProjectCont38 = _vm.detailProjectContract) === null || _vm$detailProjectCont38 === void 0 ? void 0 : _vm$detailProjectCont38.id,
      "open-inspection-checklist-slide": _vm.openInspectionChecklistSlide
    }
  })], 1) : _vm._e(), _vm.activeTab === 3 ? _c('div', {
    staticClass: "w-75 mx-auto d-flex flex-column align-items-center overflow-auto",
    staticStyle: {
      "max-height": "80vh"
    },
    attrs: {
      "id": "pfa"
    }
  }, [_c('SlideFormPFA', {
    attrs: {
      "project_contract_id": (_vm$detailProjectCont39 = _vm.detailProjectContract) === null || _vm$detailProjectCont39 === void 0 ? void 0 : _vm$detailProjectCont39.id
    },
    on: {
      "uploaded": function uploaded() {/* preview tab: nothing to refresh here */},
      "close": function close() {/* no sidebar here; noop */}
    }
  })], 1) : _vm._e(), _vm.activeTab === 4 ? _c('div', {
    attrs: {
      "id": "spal-process"
    }
  }, [_c('SlideSpalProcess', {
    attrs: {
      "id": (_vm$detailProjectCont40 = _vm.detailProjectContract) === null || _vm$detailProjectCont40 === void 0 ? void 0 : _vm$detailProjectCont40.id,
      "closeSlideSpalProcess": function closeSlideSpalProcess() {},
      "action": 'PREVIEW'
    }
  })], 1) : _vm._e(), _vm.activeTab === 5 ? _c('div', {
    attrs: {
      "id": "trip-document"
    }
  }, [_c('TabTripDocument', {
    attrs: {
      "projectData": _vm.detailProjectContract,
      "showVehicleName": _vm.showVehicleName
    }
  })], 1) : _vm._e(), _vm.activeTab === 6 ? _c('div', {
    attrs: {
      "id": "payment-list"
    }
  }, [_c('TabPaymentList', {
    attrs: {
      "projectData": _vm.detailProjectContract,
      "showVehicleName": _vm.showVehicleName
    }
  })], 1) : _vm._e(), _vm.activeTab === 7 ? _c('div', {
    attrs: {
      "id": "real-shipment"
    }
  }, [_c('TabRealShipment', {
    attrs: {
      "projectData": _vm.detailProjectContract,
      "optionsFleets": _vm.optionsFleets,
      "showVehicleName": _vm.showVehicleName
    }
  })], 1) : _vm._e(), _c('b-sidebar', {
    attrs: {
      "id": "new-customer",
      "title": "NEW CUSTOMER",
      "width": "100%",
      "backdrop-variant": "dark",
      "bg-variant": "white",
      "right": "",
      "backdrop": "",
      "shadow": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref4) {
        var hide = _ref4.hide;
        return [_c('b-row', {
          staticClass: "m-3"
        }, [_c('b-col', {
          attrs: {
            "cols": "12"
          }
        }, [_c('fieldset', {
          staticClass: "form-group border p-3"
        }, [_c('legend', {
          staticClass: "w-auto px-2 text-primary"
        }, [_vm._v("Customers")]), _c('b-row', {
          staticClass: "mt-2"
        }, [_c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('FormCustomer', {
          attrs: {
            "is-edit": false,
            "edit-id": null,
            "refresh-data": _vm.handleCreateNewCustomer,
            "optionsCustomerClass": _vm.optionsCustomerClass
          }
        })], 1)], 1)], 1)])], 1)];
      }
    }], null, false, 1421253443),
    model: {
      value: _vm.slideNewCustomer,
      callback: function callback($$v) {
        _vm.slideNewCustomer = $$v;
      },
      expression: "slideNewCustomer"
    }
  })], 1)], 1)], 1) : _c('div', {
    staticClass: "d-flex flex-column align-items-center justify-content-center w-100"
  }, [_vm._m(0), _vm._m(1), _vm._m(2)]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "spinner-border text-muted",
    attrs: {
      "role": "status"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Loading...")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('h3', {
    staticClass: "text-muted mt-3"
  }, [_c('strong', [_vm._v("fetching data...")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('h5', {
    staticClass: "text-muted mt-1"
  }, [_c('strong', [_vm._v("Please wait a moment")])]);

}]

export { render, staticRenderFns }